import { getApiClient } from '@plandi/common'
import { components } from '@plandi/common/src/generated'

export const sharedApi = {
  getSEOText: (locale: string) =>
    getApiClient(locale)
      .get<components['schemas']['SEOTextResource']>('v1/seo/get')
      .then(({ data }) => data),

  getMySubscription: (locale: string) =>
    getApiClient(locale)
      .get<components['schemas']['SubscriptionMeResource']>(
        '/v1/subscriptions/model/me'
      )
      .then(({ data }) => data),

  getTranslate: (lang?: string) =>
    getApiClient(lang ?? 'en')
      .get<components['schemas']['Translate']>(`v1/localization/${lang}`)
      .then(({ data }) => data.data)
}
